var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.classNames,attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.$emit('blur', $event.target.value)},"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }